export const FETCH_PUBLISHED_TEMPLATE_REQUEST = 'FETCH_PUBLISHED_TEMPLATE_REQUEST'
export const FETCH_PUBLISHED_TEMPLATE_SUCCESS = 'FETCH_PUBLISHED_TEMPLATE_SUCCESS'
export const FETCH_PUBLISHED_TEMPLATE_FALUIRE = 'FETCH_PUBLISHED_TEMPLATE_FALUIRE'
